import { render, staticRenderFns } from "./AstroCalendarExport.vue?vue&type=template&id=59a013d2&scoped=true&"
import script from "./AstroCalendarExport.vue?vue&type=script&lang=js&"
export * from "./AstroCalendarExport.vue?vue&type=script&lang=js&"
import style0 from "./AstroCalendarExport.vue?vue&type=style&index=0&id=59a013d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a013d2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDatePicker,VDialog,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59a013d2')) {
      api.createRecord('59a013d2', component.options)
    } else {
      api.reload('59a013d2', component.options)
    }
    module.hot.accept("./AstroCalendarExport.vue?vue&type=template&id=59a013d2&scoped=true&", function () {
      api.rerender('59a013d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/共時曆/AstroCalendarExport.vue"
export default component.exports